import { DatePipe } from '@angular/common';
import { Component, AfterViewInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ShareddtaService } from '@app/services/shareddta.service';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ReusableGoogleMapComponent } from '@app/components/reusable-google-map/reusable-google-map.component';
import { AuthServiceService } from '@app/services/auth-service.service';
import { DialogService } from '@app/services/dialog.service';
import { OrderService } from '@app/services/order.service';
import { ToastService } from '@app/services/toast.service';
import { ToastrService } from 'ngx-toastr';
import { Location } from '@angular/common';
import { BreadcrumbService } from '@app/services/breadcrumb.service';
interface NotificationItem {
  id: string;
  message: string;
  time: string;
  isUnread: boolean;
  hasImage?: boolean;
  imageUrl?: string;
  type: 'customer' | 'driver';
}
@Component({
  selector: 'app-order-detail',
  templateUrl: './order-detail.component.html',
  styleUrl: './order-detail.component.scss'
})
export class OrderDetailComponent implements AfterViewInit {
  // Loading state
  isLoading: boolean = false;

  // Order Data
  orderStatus = '';

  // Driver Assignment
  driverAssigned: boolean = false;
  driverName = 'Sandeep S';
  driverInitials = 'SS';
  driverAssignedDate = 'Friday, January 9, 2026';

  // Contact Information
  id: any;
  invoiceImageSrc: any = 'assets/images/edit-icon.png';
  receiverImage: any = 'assets/images/edit-icon.png';
  unsuccessfullReasons: any = [];
  // Status Timeline
  // statusSteps = [
  //   {
  //     label: 'Processed',
  //     icon: 'clipboard-check',
  //     completed: true,
  //     active: false,
  //     time: 'Jan 8, 11:59 PM'
  //   },
  //   {
  //     label: 'Shipped',
  //     icon: 'cube',
  //     completed: true,
  //     active: false,
  //     time: 'Jan 9, 8:00 AM'
  //   },
  //   {
  //     label: 'En route',
  //     icon: 'truck',
  //     completed: false,
  //     active: true,
  //     time: 'Estimated: 12:00 PM'
  //   },
  //    {
  //     label: 'Arrived',
  //     icon: 'truck',
  //     completed: false,
  //     active: true,
  //     time: 'Estimated: 12:00 PM'
  //   },
  //   {
  //     label: 'Delivered',
  //     icon: 'check-circle',
  //     completed: false,
  //     active: false,
  //     time: ''
  //   }
  // ];
  statusFlow = [
    { key: 'pending', label: 'PROCESSED', icon: 'clipboard-check' },
    { key: 'shipped', label: 'SHIPPED', icon: 'cube' },
    { key: 'en-route', label: 'EN ROUTE', icon: 'truck' },
    { key: 'arrived', label: 'ARRIVED', icon: 'map-pin' },
    { key: 'successful', label: 'DELIVERED', icon: 'check-circle' },
    { key: 'unsuccessful', label: 'UNSUCCESSFUL', icon: 'check-circle' },
    { key: 'cancelled', label: 'CANCELLED', icon: 'check-circle' }
  ];

  // Notification Panel
  isNotificationPanelOpen = false;
  activeTab: 'customer' | 'driver' = 'customer';
  customerUnreadCount = 2;
  driverUnreadCount = 0;

  notifications: NotificationItem[] = [
    {
      id: '1',
      message: 'Please be ready to pick the order - Packing slip attached',
      time: '26 seconds ago',
      isUnread: true,
      hasImage: true,
      imageUrl: 'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=600&h=400&fit=crop',
      type: 'customer'
    },
    {
      id: '2',
      message: 'Hello',
      time: '43 seconds ago',
      isUnread: true,
      hasImage: false,
      type: 'customer'
    },
    {
      id: '3',
      message: 'Your order #6252661 is out for delivery - Driver location shared',
      time: '2 hours ago',
      isUnread: false,
      hasImage: true,
      imageUrl: 'https://images.unsplash.com/photo-1524661135-423995f22d0b?w=600&h=400&fit=crop',
      type: 'customer'
    },
    {
      id: '4',
      message: 'Order #6252660 has been delivered successfully',
      time: '5 hours ago',
      isUnread: false,
      hasImage: false,
      type: 'customer'
    },
    {
      id: '5',
      message: 'Driver Sandeep has been assigned to order #6252662',
      time: 'Yesterday',
      isUnread: false,
      hasImage: false,
      type: 'customer'
    },
    {
      id: '6',
      message: 'Payment received for order #6252659',
      time: '2 days ago',
      isUnread: false,
      hasImage: false,
      type: 'customer'
    }
  ];

  // Upload
  selectedFile: File | null = null;
  uploadedImageUrl: string | null = null;
  isUploading = false;

  // Signature Modal
  isSignatureModalOpen = false;
  signatureModalImage: string | null = null;

  // Notification Mode
  notificationRecipient: 'driver' | 'customer' = 'customer';

  mapEmbedUrl: SafeResourceUrl | null = null;

  constructor(public router: Router, private route: ActivatedRoute, private orderService: OrderService, private authService: AuthServiceService, private dialog: MatDialog,
    private toastr: ToastrService, private dialogService: DialogService, private toast: ToastService, private shareddta: ShareddtaService, public location: Location,
    private breadcrumbService: BreadcrumbService, private sanitizer: DomSanitizer) {
    this.id = this.route.snapshot.params['id'];
  }

  ngOnInit(): void {
    if (this.id) {
      this.orderDetail(this.id);
      this.notificationRecipient = 'driver';
    }
  }

  ngAfterViewInit(): void {
    this.shareddta.signalPageReady();
  }

  // Status Animation
  // animateStatusProgress(): void {
  //   const progressLine = document.querySelector('.status-line-progress') as HTMLElement;
  //   if (progressLine) {
  //     // Calculate progress based on completed steps
  //     const completedSteps = this.statusSteps.filter(s => s.completed).length;
  //     const totalSteps = this.statusSteps.length;
  //     const progressPercent = ((completedSteps - 1) / (totalSteps - 1)) * 100;

  //     setTimeout(() => {
  //       progressLine.style.width = `${progressPercent}%`;
  //     }, 300);
  //   }
  // }
  //   animateStatusProgress(): void {
  //   const progressLine = document.querySelector('.status-line-progress') as HTMLElement;
  //   if (!progressLine || !this.statusSteps || this.statusSteps.length < 2) return;

  //   const completedSteps = this.statusSteps.filter(s => s.completed).length;
  //   const totalSteps = this.statusSteps.length;

  //   // 🔹 Avoid divide by zero or negative width
  //   const progressPercent = totalSteps > 1
  //     ? ((completedSteps - 1) / (totalSteps - 1)) * 100
  //     : 0;

  //   setTimeout(() => {
  //     progressLine.style.width = `${Math.max(progressPercent, 0)}%`;
  //   }, 300);
  // }
  truckPosition = 0; // Truck left position in %
  animateStatusProgress(): void {
    if (!this.statusSteps || this.statusSteps.length < 2) return;

    const completedSteps = this.statusSteps.filter(s => s.completed).length;
    const totalSteps = this.statusSteps.length;

    const progressPercent = totalSteps > 1
      ? ((completedSteps) / (totalSteps)) * 100
      : 0;

    // Delay to allow *ngIf="!isLoading" to render the DOM first
    setTimeout(() => {
      const progressLine = document.querySelector('.status-line-progress') as HTMLElement;
      if (progressLine) {
        progressLine.style.width = `${Math.max(progressPercent, 0)}%`;
      }
      this.truckPosition = Math.max(progressPercent, 0);
    }, 500);
  }


  // Navigation
  goBack(): void {
    // this.router.navigate([`/${this.authService._isRoleName}/dashboard`]);
    this.location.back();
  }

  // Actions
  editOrder(orderData: any): void {
    localStorage.setItem('vieworderdetailid', orderData.id);
    const orderId = orderData?.parent_order ? orderData.parent_order : orderData.id;
    this.router.navigate(['admin/orders/edit', orderId], { queryParams: { fromDetail: true } });
    // Implement edit functionality
  }

  // deleteOrder(): void {
  //   if (confirm('Are you sure you want to delete this order?')) {
  //     console.log('Delete order:', '');
  //     // Implement delete functionality
  //   }
  // }

  // Driver Actions
  reassignDriver(): void {
    console.log('Reassign driver');
    // Implement reassign functionality
  }

  // unassignDriver(): void {
  //   if (confirm('Are you sure you want to unassign this driver?')) {
  //     console.log('Unassign driver');
  //     this.driverAssigned = false;
  //     // Implement unassign functionality
  //   }
  // }

  // Upload
  uploadPackingSlip(): void {
    if (this.selectedFile) {
      this.startUpload();
    } else {
      document.getElementById('fileInput')?.click();
    }
  }

  handleFileUpload(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];

    if (!file) return;

    this.selectedFile = file;

    // Preview the image locally
    const reader = new FileReader();
    reader.onload = (e: ProgressEvent<FileReader>) => {
      this.uploadedImageUrl = e.target?.result as string;
    };
    reader.readAsDataURL(file);
  }

  startUpload(): void {
    if (!this.selectedFile) return;

    this.isUploading = true;
    const formData = new FormData();
    formData.append('order', JSON.stringify(Number(this.orderData?.id)));
    formData.append('invoice_doc', this.selectedFile);

    this.orderService.uploadInvoice(formData).subscribe({
      next: (res: any) => {
        if (this.authService.resultCodeError(res)) {
          this.isUploading = false;
          return;
        }
        this.uploadedImageUrlId = res?.result?.id;
        this.selectedFile = null; // Reset selection after success
        this.isUploading = false;
        this.toast.show('success', 'Invoice Uploaded Successfully');
      },
      error: (err: any) => {
        this.isUploading = false;
        this.authService.dataError(err);
      }
    });
  }



  clearUpload(): void {
    this.selectedFile = null;
    this.uploadedImageUrl = null;
    const fileInput = document.getElementById('fileInput') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }

    // Only call API if it exists on the server
    if (!this.uploadedImageUrlId) {
      return;
    }

    const formData = new FormData();
    formData.append('invoice_id', JSON.stringify(Number(this.uploadedImageUrlId)));
    formData.append('delete', 'True');

    this.orderService.uploadInvoice(formData).subscribe({
      next: (res: any) => {
        if (this.authService.resultCodeError(res)) {
          return;
        }

        this.uploadedImageUrlId = null; // Clear ID after successful deletion
        this.toast.show('success', 'Invoice deleted successfully');
      },
      error: (err: any) => {
        this.toast.show('error', 'Failed to delete invoice');
        this.authService.dataError(err);
      }
    });
  }

  // Phone
  copyToClipboard(text: string): void {
    navigator.clipboard.writeText(text).then(() => {
      console.log('Copied to clipboard:', text);
      this.toast.show('success', ' Copied!');
      // Show toast notification
    }).catch(err => {
      console.error('Failed to copy:', err);
    });
  }

  getDriverFullName(): string {
    if (!this.orderData?.current_driver || !this.orderData.current_driver.id) return 'Not assigned';
    const cd = this.orderData.current_driver;
    const name = `${cd.first_name || ''} ${cd.last_name || ''}`.trim();
    if (cd.phone_number?.toLowerCase().includes('truck') || name.toLowerCase().includes('truck')) {
      return name || 'Truck';
    }
    return name || 'Not assigned';
  }

  hasDriverPhone(): boolean {
    const cd = this.orderData?.current_driver;
    if (!cd || Object.keys(cd).length === 0 || !cd.id) return false;
    if (cd.is_virtual_user === true) return false;
    const phone = cd.phone_number;
    if (!phone || phone === 'null' || phone === 'undefined' || String(phone).trim() === '') return false;
    if (String(phone).toLowerCase().includes('truck')) return false;
    return true;
  }

  getDriverPhonePlaceholder(): string {
    const cd = this.orderData?.current_driver;
    if (!cd || Object.keys(cd).length === 0 || !cd.id) {
      return 'No driver assigned';
    }
    const name = `${cd.first_name || ''} ${cd.last_name || ''}`.toLowerCase();
    const phone = cd.phone_number ? String(cd.phone_number).toLowerCase() : '';
    if (cd.is_virtual_user === true || phone.includes('truck') || name.includes('truck')) {
      return 'Not applicable';
    }
    return 'Not available';
  }

  getCustomerAltPhone(): string | null {
    if (!this.orderData) return null;
    const alt = this.orderData.customer_alt_phone ||
      (this.orderData.order_type === 'delivery' ? this.orderData.dely_alt_phone : this.orderData.pickup_alt_phone);
    if (!alt || alt === 'null' || alt === 'undefined' || String(alt).trim() === '') {
      return null;
    }
    return String(alt).trim();
  }

  getCustomerAltPhoneFull(): string {
    const alt = this.getCustomerAltPhone();
    if (!alt) return '';
    if (alt.startsWith('+')) return alt;
    return (this.orderData?.country_code || '') + alt;
  }

  // Notification
  toggleNotificationMode(mode: 'driver' | 'customer'): void {
    this.notificationRecipient = mode;
    this.recipientType = this.notificationRecipient;
  }

  // sendNotification(): void {
  //   console.log('Send notification to:', this.notificationRecipient);
  //   // Implement send notification functionality
  // }

  // Notification Panel
  openNotifications(): void {
    this.isNotificationPanelOpen = true;
    this.orderDetailRnD = [];
    this.setActiveTab('customer');
  }
  orderDetailRn: any;
  orderDetailRnD: any;

  setActiveTab(tab: 'customer' | 'driver'): void {
    this.activeTab = tab;

    this.orderService.orderDetailRNC(this.id, this.activeTab).subscribe(
      (data: any) => {
        // 🔹 Check API response error
        if (this.authService.resultCodeError(data)) {
          return;
        }

        if (this.activeTab == 'customer') { this.orderDetailRn = data?.result?.results || []; }
        if (this.activeTab == 'driver') { this.orderDetailRnD = data?.result?.results || []; }
        console.log('Order Notifications:', this.orderDetailRn);
      },
      (error: any) => {
        this.authService.dataError(error);
      }
    );
  }
  setActiveTabAll(tab: 'customer' | 'driver'): void {
    this.activeTab = tab;

    this.orderService.orderDetailAllRNC(this.id, this.activeTab).subscribe(
      (data: any) => {
        // 🔹 Check API response error
        if (this.authService.resultCodeError(data)) {
          return;
        }

        if (this.activeTab == 'customer') { this.orderDetailRn = data?.result?.results || []; }
        if (this.activeTab == 'driver') { this.orderDetailRnD = data?.result?.results || []; }
        console.log('Order Notifications:', this.orderDetailRn);
      },
      (error: any) => {
        this.authService.dataError(error);
      }
    );
  }

  closeNotifications(): void {
    this.isNotificationPanelOpen = false;
  }

  switchTab(tab: 'customer' | 'driver'): void {
    this.activeTab = tab;
  }

  get filteredNotifications(): NotificationItem[] {
    return this.notifications.filter(n => n.type === this.activeTab);
  }

  markAsRead(notification: NotificationItem): void {
    if (notification.isUnread) {
      notification.isUnread = false;

      // Update badge count
      if (notification.type === 'customer') {
        this.customerUnreadCount = Math.max(0, this.customerUnreadCount - 1);
      } else {
        this.driverUnreadCount = Math.max(0, this.driverUnreadCount - 1);
      }
    }
  }

  viewImage(imageUrl: string): void {
    // Implement image viewer modal
    console.log('View image:', imageUrl);
  }

  viewAllNotifications(): void {
    this.orderDetailRnD = [];
    console.log('View all notifications for:', this.activeTab);
    this.setActiveTabAll(this.activeTab);
    // Navigate to full notifications page
  }

  // Signature Modal Methods
  openSignatureModal(imageUrl: string): void {
    if (imageUrl) {
      this.signatureModalImage = imageUrl;
      this.isSignatureModalOpen = true;
    }
  }

  closeSignatureModal(): void {
    this.isSignatureModalOpen = false;
    this.signatureModalImage = null;
  }

  // Helpers
  getStatusBadgeClass(): string {
    switch (this.orderStatus) {
      case 'pending': return 'pending';
      case 'unsuccessful': return 'unsuccessful';
      case 'successful': return 'successful';
      case 'en-route': return 'en-route';
      case 'shipped': return 'shipped';
      case 'warehouse': return 'warehouse';
      case 'arrived': return 'arrived';
      case 'cancelled': return 'cancelled';
      default: return 'pending';
    }
  }

  getStatusBadgeText(): string {
    return this.orderStatus.toUpperCase();
  }
  closeModal(): void {
    this.isModalOpen = false;
    this.showError = false;
    this.resetForm();
  }
  messageText: string = '';
  selectedFiles: File[] = [];
  filePreviews: { file: File; url: string }[] = [];
  charCount: number = 0;
  maxChars: number = 500;
  recipientType: 'customer' | 'driver' | 'all' = 'driver';
  isModalOpen: boolean = false;
  resetForm(): void {
    this.messageText = '';
    this.selectedFiles = [];
    this.filePreviews = [];
    this.charCount = 0;
  }
  toggleRecipientType(type: 'customer' | 'driver'): void {
    this.recipientType = type;
    this.notificationRecipient = this.recipientType;
  }
  showError: boolean = false;
  sendNotification(): void {
    if (!this.messageText.trim()) {
      this.showError = true;
      return;
    }
    this.showError = false;

    const formData = new FormData();

    // message
    formData.append('message', this.messageText);

    // send_to mapping
    const sendTo = this.recipientType === 'customer' ? 'Customer' : 'Driver';
    formData.append('send_to', sendTo);

    // images from your onFileSelect
    if (this.selectedFiles.length > 0) {
      this.selectedFiles.forEach((file: File) => {
        formData.append('notification_image', file, file.name);
      });
    }

    // optional fields
    if (this.id) {
      formData.append('order_id', this.id);
    }

    formData.append('title', 'Custom Order Notification');

    this.orderService.sendNotificationToDriverCustomer(formData)
      .subscribe((res: any) => {
        if (res?.resultCode == '0') {
          this.toast.show('error', res?.errorMessage);
        } else if (res.resultDescription) {
          this.toast.show('success', res?.resultDescription || 'Notification sent successfully');
        }
      }, () => {
        this.toast.show('error', 'Failed to Send Notification');;
      });
    this.closeModal();
  }

  removeFile(index: number): void {
    this.selectedFiles.splice(index, 1);
    this.filePreviews.splice(index, 1);
  }
  onFileSelect(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const files = Array.from(input.files);

      files.forEach(file => {
        if (file.type.startsWith('image/')) {
          this.selectedFiles.push(file);

          const reader = new FileReader();
          reader.onload = (e: any) => {
            this.filePreviews.push({
              file: file,
              url: e.target.result
            });
          };
          reader.readAsDataURL(file);
        }
      });
    }
  }
  getCharCountClass(): string {
    if (this.charCount >= 450) return 'limit-danger';
    if (this.charCount >= 400) return 'limit-warning';
    return '';
  }
  updateCharCount(): void {
    this.charCount = this.messageText.length;
  }
  openModal(): void {
    this.isModalOpen = true;
    this.resetForm();
  }
  onBackdropClick(event: MouseEvent): void {
    if ((event.target as HTMLElement).classList.contains('modal')) {
      this.closeModal();
    }
  }
  orderData: any;
  uploadedImageUrlId: any;

  getOrderAddress(): any {
    if (!this.orderData) return null;
    const isParentNull = this.orderData.parent_order == null;
    if (isParentNull) {
      return this.orderData.order_type === 'delivery' 
        ? this.orderData.dely_address 
        : this.orderData.pickup_address;
    } else {
      return this.orderData.dely_address;
    }
  }

  updateMapEmbedUrl(): void {
    const addressObj = this.getOrderAddress();
    const lat = addressObj?.latitude;
    const lng = addressObj?.longitude;
    const addressStr = addressObj?.address || this.orderData?.customer_addr;

    let url = '';
    if (lat && lng && !isNaN(Number(lat)) && !isNaN(Number(lng)) && Number(lat) !== 0 && Number(lng) !== 0) {
      url = `https://maps.google.com/maps?q=${lat},${lng}&z=15&output=embed`;
    } else if (addressStr) {
      url = `https://maps.google.com/maps?q=${encodeURIComponent(addressStr)}&z=15&output=embed`;
    }
    this.mapEmbedUrl = url ? this.sanitizer.bypassSecurityTrustResourceUrl(url) : null;
  }

  orderDetail(id: number) {
    this.isLoading = true;
    this.orderService.orderDetail(id).subscribe({
      next: (data: any) => {
        this.isLoading = false;
        // 🔹 Safety: resultCodeError already handled in service, but keeping for double safety
        if (this.authService.resultCodeError(data)) {
          return;
        }

        this.orderData = data?.result;
        if (this.orderData?.current_driver && 
            this.orderData.current_driver.is_virtual_user === true && 
            this.orderData.current_driver.is_deleted === true) {
          this.orderData.current_driver = null;
        }
        if (this.orderData?.order_invoice?.length > 0) {
          this.uploadedImageUrl = this.orderData.order_invoice[this.orderData.order_invoice?.length - 1].invoice_doc;
          this.uploadedImageUrlId = this.orderData.order_invoice[this.orderData.order_invoice?.length - 1].id;
        }
        this.orderStatus = this.orderData.order_status;
        this.updateMapEmbedUrl();
        if (!this.orderData) return;

        // Set global breadcrumb
        const orderLabel = this.orderData.parent_order == null 
            ? (this.orderData.order_type === 'pickup' ? this.orderData.po : this.orderData.order_no)
            : this.orderData.order_no;

        const finalLabel = orderLabel || `Order #${this.id}`;

        this.breadcrumbService.set([
          { label: 'Orders', icon: 'M11 17a1 1 0 001.447.894l4-2A1 1 0 0017 15V9.236a1 1 0 00-1.447-.894l-4 2a1 1 0 00-.553.894V17zM15.211 6.276a1 1 0 000-1.788l-4.764-2.382a1 1 0 00-.894 0L4.789 4.488a1 1 0 000 1.788l4.764 2.382a1 1 0 00.894 0l4.764-2.382zM4.447 8.342A1 1 0 003 9.236V15a1 1 0 00.553.894l4 2A1 1 0 009 17v-5.764a1 1 0 00-.553-.894l-4-2z', action: () => this.router.navigate(['/admin/dashboard']) },
          { label: finalLabel }
        ]);

        // 🔹 Store parent order id
        localStorage.setItem('parentorderid', this.orderData.id);

        // 🔹 Last invoice image
        const invoices = this.orderData?.order_invoice;
        if (invoices?.length > 0) {
          this.invoiceImageSrc = invoices[invoices.length - 1].invoice_doc;
        }

        // 🔹 Last receiver image
        const receivers = this.orderData?.receiver_details;
        if (receivers?.length > 0) {
          this.receiverImage = receivers[receivers.length - 1]?.photo;
        }

        // 🔹 Collect unsuccessful reasons safely
        this.unsuccessfullReasons = [];
        this.orderData?.status_history?.forEach((elt: any) => {

          if (elt.status === 'unsuccessful' ||
            elt.status === 'successful' ||
            elt.status === 'cancelled') {

            elt.status_reason?.forEach((reason: any) => {

              if (
                reason &&
                !this.unsuccessfullReasons.some(
                  (r: any) => JSON.stringify(r) === JSON.stringify(reason)
                )
              ) {
                this.unsuccessfullReasons.push({ ...reason, status: elt.status });
              }

            });
          }

        });
        if (
          this.orderData?.current_driver &&
          Object.keys(this.orderData.current_driver).length > 0
        ) {
          this.driverAssigned = true;
        } else {
          this.driverAssigned = false;
        }

        this.buildStatusStepsFromApi(this.orderData);
      },
      error: (error) => {
        this.isLoading = false;
        this.authService.dataError(error);
      }
    });
  }
  convertToLocalDate(utcDateString: string | null): string {
    if (!utcDateString) {
      return '';
    }
    const datePipe = new DatePipe('en-US');
    const utcDate = new Date(utcDateString);
    const currentYear = new Date().getFullYear();
    if (utcDate.getFullYear() !== currentYear) {
      return datePipe.transform(utcDate, 'EEE MMM dd yyyy') || '';
    }
    return datePipe.transform(utcDate, 'EEE MMM dd') || '';
  }
  getFormattedTime1(): string {
    if (this.orderData && this.orderData.pickup_time) {
      const timeParts = this.orderData.pickup_time.split(':');
      let hours = parseInt(timeParts[0], 10);
      const minutes = timeParts[1];
      const ampm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12 || 12;
      const formattedTime = `${hours}:${minutes} ${ampm}`;
      return formattedTime;
    } else {
      return '';
    }
  }
  getFormattedTime(): string {
    if (this.orderData && this.orderData.dely_time) {
      const timeParts = this.orderData.dely_time.split(':');
      let hours = parseInt(timeParts[0], 10);
      const minutes = timeParts[1];
      const ampm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12 || 12;
      const formattedTime = `${hours}:${minutes} ${ampm}`;
      return formattedTime;
    } else {
      return '';
    }
  }
  statusSteps: any[] = [];

  buildStatusStepsFromApi(orderData: any) {
    const history = orderData?.status_history || [];
    if (!history.length) return;

    // latest status
    const latestStatus = history[history.length - 1].status;

    const terminalStatuses = ['successful', 'unsuccessful', 'cancelled'];

    // map history for faster lookup
    const historyMap = history.reduce((acc: any, h: any) => {
      acc[h.status] = h;
      return acc;
    }, {});

    // check if any terminal status is in history
    const terminalInHistory = terminalStatuses.find(ts => !!historyMap[ts]);

    this.statusSteps = this.statusFlow
      .filter(step => {
        // 🔹 agar step terminal hai
        if (terminalStatuses.includes(step.key)) {
          // sirf woh terminal step show karo jo history me hai
          return step.key === terminalInHistory;
        }
        return true; // baaki steps hamesha show karo
      })
      .map(step => {
        const historyEntry = historyMap[step.key];
        const isCompleted = !!historyEntry;
        const isActive = !!historyEntry;

        return {
          ...step,
          completed: isCompleted,
          active: isActive,
          isCurrent: false, // Default
          time: historyEntry
            ? this.formatDateTime(historyEntry.created_at)
            : isActive
              ? 'In progress'
              : ''
        };
      });

    // Mark the LAST active step as the current one
    const lastActiveIndex = [...this.statusSteps].reverse().findIndex(s => s.active);
    if (lastActiveIndex !== -1) {
      const realIndex = this.statusSteps.length - 1 - lastActiveIndex;
      this.statusSteps[realIndex].isCurrent = true;
    }

    this.animateStatusProgress();
  }

  formatDateTime(dateStr: string | Date): string {
    const date = new Date(dateStr);

    const datePart = date.toLocaleDateString('en-US', {
      month: 'short',
      day: '2-digit',
      year: 'numeric'
    });

    const timePart = date.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });

    return `${datePart}\n${timePart}`;
  }
  getDriverInitials(driver: any): string {
    if (!driver || !driver.first_name || !driver.last_name) {
      return '';
    }

    const first = driver.first_name.charAt(0).toUpperCase();
    const last = driver.last_name.charAt(0).toUpperCase();

    return first + last;
  }
  async rescheduleOrder(): Promise<void> {
    const confirmed = await this.dialogService.confirm(
      'Reschedule Row',
      'Are you sure you want to reschedule this order? This action cannot be undone.',
      'Reschedule',
      'Cancel'
    );

    if (confirmed?.confirmed) {
      this.orderService.ordereschedule(this.id).subscribe(
        (data: any) => {
          if (this.authService.resultCodeError(data)) {
            return;
          }
          this.toast.show('success', data?.resultDescription);
          // this.router.navigateByUrl(`/${this._isRoleName}/dashboard`);
          this.orderDetail(this.id);
        },
        (error) => {
          this.authService.dataError(error);
        }
      );
      // console.log("FormData Value:", formdata.get('order_ids'));
    }
  }
  async unassignDriver(): Promise<void> {
    const confirmed = await this.dialogService.confirm(
      'Unassign Order',
      'Are you sure you want to unassign this order? This action cannot be undone.',
      'Unassign',
      'Cancel'
    );

    if (confirmed?.confirmed) {
      var formdata = new FormData();
      formdata.append('order_ids', JSON.stringify([Number(this.id)]));
      this.orderService.orderunAssign(formdata).subscribe(
        (data: any) => {
          if (this.authService.resultCodeError(data)) {
            return;
          }
          if (data.resultDescription) {
            this.toast.show('success', data?.resultDescription);
            this.orderDetail(this.id);
          }
        },
        (error) => {
          this.authService.dataError(error);
        }
      );
      // console.log("FormData Value:", formdata.get('order_ids'));
    }
  }
  showAssignOrderModal = false;
  showAssign = false;
  selectedOrders: string[] = [];
  assignorder: boolean = false;
  openReAssignOrder() {
    this.assignorder = true
    this.showAssign = false;
    const ids = this.id;
    this.selectedOrders = [ids];
    this.showAssignOrderModal = true;
  }
  handleAssignOrder(event: { driver: string, orders: string[] }) {
    console.log('Assigned Orders:', event.orders, 'to', event.driver);
    const isDriverValid = event.driver && String(event.driver).trim() !== '';
    this.assignorder = false;
    if (!isDriverValid) {
      console.warn('Driver not selected!');
      // 🔹 You can set a variable to false
      this.assignorder = false;  // example variable
      return; // exit if driver not valid
    }
    const ids = this.id;
    const formdata = new FormData();
    formdata.append('order_ids', JSON.stringify([ids]));
    formdata.append('driver_id', event.driver);  // ✅ yahin se aa raha hai

    this.orderService.orderAssign(formdata).subscribe(
      (data: any) => {
        if (this.authService.resultCodeError(data)) return;
        if (data.resultDescription) {
          this.toast.show('success', data?.resultDescription);
          this.orderDetail(this.id);
        }
      },
      (error) => {
        this.authService.dataError(error);
      }
    );
    // Call API to assign orders here
  }
  async deleteOrder(): Promise<void> {
    const confirmed = await this.dialogService.confirm(
      'Delete Row',
      'Are you sure you want to delete this order? This action cannot be undone.',
      'Delete',
      'Cancel'
    );

    if (confirmed?.confirmed) {
      var formdata = new FormData();
      formdata.append('order_ids', JSON.stringify([this.id]));
      // console.log("FormData Value:", formdata.get('order_ids'));
      this.orderService.orderDelete(formdata).subscribe(
        (data: any) => {
          if (this.authService.resultCodeError(data)) {
            return;
          }
          // 1. Clean Main Dashboard Cache
          const cache = localStorage.getItem('ordersCache');
          if (cache) {
            let orders = JSON.parse(cache);
            orders = orders.filter((order: any) => Number(order.id) !== Number(this.id));
            localStorage.setItem('ordersCache', JSON.stringify(orders));
          }

          // 2. Clean Archive Cache & Total Count
          const arkiveCache = localStorage.getItem('arkiveOrdersCache');
          if (arkiveCache) {
            let arkiveOrders = JSON.parse(arkiveCache);
            const initialLength = arkiveOrders.length;
            const targetId = this.id.toString();
            arkiveOrders = arkiveOrders.filter((order: any) => order.id.toString() !== targetId);

            if (arkiveOrders.length < initialLength) {
              localStorage.setItem('arkiveOrdersCache', JSON.stringify(arkiveOrders));

              const arkiveTotal = localStorage.getItem('arkiveTotalOrders');
              if (arkiveTotal) {
                const newTotal = Math.max(0, parseInt(arkiveTotal, 10) - 1);
                localStorage.setItem('arkiveTotalOrders', newTotal.toString());
              }

              // 🔹 SYNC BADGES: Decrement the specific status count in localStorage
              const arkiveStatusStr = localStorage.getItem('arkiveStatusCounts');
              if (arkiveStatusStr && this.orderData?.order_status) {
                const statusCounts = JSON.parse(arkiveStatusStr);
                const statusToUpdate = this.orderData.order_status;
                const statusObj = statusCounts.find((s: any) => s.order_status === statusToUpdate);
                if (statusObj) {
                  statusObj.count = Math.max(0, statusObj.count - 1);
                  localStorage.setItem('arkiveStatusCounts', JSON.stringify(statusCounts));
                }
              }
            }
          }

          // 3. Keep Flow State (Standard UX: Stay on current page/scroll)
          localStorage.setItem('arkiveFromOrderDetail', 'true');
          localStorage.setItem('fromOrderDetail', 'true');

          // 🧹 GHOST CLEAR: Wipe service-level subjects to prevent old results/counts from appearing
          const s = this.orderService as any;
          s._arkiveorder?.next(null);
          s._arkiveorderss?.next(null);
          s._arkiveorderCount?.next(null);

          this.toast.show('success', data?.resultDescription);
          this.goBack();
        },
        (error) => {
          this.authService.dataError(error);
        }
      );
    }
  }
  // getMultipleOrderIds(item: any): string {
  //   if (item?.order_type === 'pickup' && item?.pickup_multiple_order_ids) {
  //     return item.pickup_multiple_order_ids.split(',').join(' - ');
  //   } else if (item?.order_type === 'delivery' && item?.dely_multiple_order_ids) {
  //     return item.dely_multiple_order_ids.split(',').join(' - ');
  //   } else if (item?.order_type === 'pickup' && item?.dely_multiple_order_ids && item.parent_order != null) {
  //     return item.dely_multiple_order_ids.split(',').join(' - ');
  //   }
  //   return '';
  // }
  getMultipleOrderIds(item: any): string {
    let ids = '';

    if (item?.order_type === 'pickup' && item?.pickup_multiple_order_ids) {
      ids = item.pickup_multiple_order_ids;
    } else if (item?.order_type === 'delivery' && item?.dely_multiple_order_ids) {
      ids = item.dely_multiple_order_ids;
    } else if (item?.order_type === 'pickup' && item?.dely_multiple_order_ids && item.parent_order != null) {
      ids = item.dely_multiple_order_ids;
    }

    // 🔥 Clean + add dash only if valid data
    const formatted = ids
      ?.split(',')
      .map((x: string) => x.trim())
      .filter((x: string) => x.length > 0)
      .join(' - ');

    return formatted ? `- ${formatted}` : '';
  }
  dialogRef: any;
  trackOrder() {
    console.log('this.orderdata', this.orderData)
    //  this.myFunction(this.title,'trackDriver');
    let enterAnimationDuration = '200ms';
    let exitAnimationDuration = '200ms';
    this.dialogRef = this.dialog.open(ReusableGoogleMapComponent, {
      width: '1100px',
      height: '90vh',
      enterAnimationDuration,
      exitAnimationDuration,
      data: {
        height: '100%',
        isShowDirections: true,
        orderData: this.orderData
      },
    });
    this.dialogRef.afterClosed().subscribe((dialogResult: any) => {
      if (dialogResult) {

      }
    });

  }

  isHistoryModalOpen: boolean = false;
  hasEditLogs(): boolean {
    if (!this.orderData?.order_logs) return false;
    return this.orderData.order_logs.some((log: any) => !log.added_by);
  }
  getAddedByName(): string | null {
    if (this.orderData?.added_by) {
      const u = this.orderData.added_by;
      return `${u.first_name || ''} ${u.last_name || ''}`.trim() || u.user_name || null;
    }
    if (this.orderData?.order_logs) {
      const log = this.orderData.order_logs.find((l: any) => l.added_by);
      if (log?.added_by) {
        const u = log.added_by;
        return `${u.first_name || ''} ${u.last_name || ''}`.trim() || u.user_name || null;
      }
    }
    return null;
  }
  openHistoryModal(): void {
    this.isHistoryModalOpen = true;
  }
  closeHistoryModal(): void {
    this.isHistoryModalOpen = false;
  }

  getLogUser(log: any): string {
    if (!log) return 'Unknown';
    if (log.changed_by) {
      if (typeof log.changed_by === 'object') {
        return `${log.changed_by.first_name || ''} ${log.changed_by.last_name || ''}`.trim() || 'Unknown';
      }
      return log.changed_by;
    }
    if (log.updated_by) {
      if (typeof log.updated_by === 'object') {
        return `${log.updated_by.first_name || ''} ${log.updated_by.last_name || ''}`.trim() || 'Unknown';
      }
      return log.updated_by;
    }
    if (log.user) {
      if (typeof log.user === 'object') {
        return `${log.user.first_name || ''} ${log.user.last_name || ''}`.trim() || 'Unknown';
      }
      return log.user;
    }
    return log.user_name || log.action_by || 'System';
  }

  getLogUserImage(log: any): string | null {
    if (!log) return null;
    const userObj = log.changed_by || log.updated_by || log.user;
    if (userObj && typeof userObj === 'object' && userObj.profile_image) {
      return userObj.profile_image;
    }
    return null;
  }

  getLogUserInitials(log: any): string {
    if (!log) return '';
    const name = this.getLogUser(log);
    if (!name || name === 'System' || name === 'Unknown') return name ? name.charAt(0) : '';
    const parts = name.split(' ');
    if (parts.length >= 2) return (parts[0].charAt(0) + parts[1].charAt(0)).toUpperCase();
    return name.charAt(0).toUpperCase();
  }

  getLogDateTime(log: any): string {
    if (!log) return '';
    const dateStr = log.changed_at || log.updated_at || log.created_at || log.timestamp || log.time || log.date;
    if (!dateStr) return '';

    const dateObj = new Date(dateStr);
    if (isNaN(dateObj.getTime())) return dateStr;

    let hours = dateObj.getHours();
    const minutes = dateObj.getMinutes().toString().padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12;
    const strHours = hours.toString().padStart(2, '0');

    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const monthStr = months[dateObj.getMonth()];
    const dayStr = dateObj.getDate().toString();

    return `${strHours}:${minutes} ${ampm}   |   ${monthStr} ${dayStr}`;
  }
}
